module.exports = __webpack_public_path__ + "img/member_trading_record_icon.c0b195a3.png";